import gql from 'graphql-tag'

import { UserProfileFragment } from './profile'

export const AuthenticationUserFragment = gql`
	fragment AuthenticationUser on User {
		id
		uid
		profileCollection {
			edges {
				node {
					...UserProfileFragment
				}
			}
		}
		_UserToCompanyRoleCollection {
			edges {
				node {
					companyRole {
						id
						company {
							id
							slug
							name
							hasLogo
							logoPath
							coverPath
							hasCover
							description
						}
					}
				}
			}
		}

		_UserToCompanyRoleCollection {
			edges {
				node {
					companyRole {
						companyRole_rolesCollection {
							edges {
								node {
									value
								}
							}
						}
					}
				}
			}
		}
		# currentPasswordCheck//need tiwari from sql
		god
		firebaseToken
	}
	${UserProfileFragment}
`

//eslint-disable-next-line
{
	/*
	fragment AuthenticationUser on User {
		id
		uid
		profile {
			...UserProfile
		}
		companyRoles {
			id
			company {
				id
				id
				slug
				name
				hasLogo
				logoPath
				coverPath
				hasCover
				description
			}
			role
			roles
		}
		currentPasswordCheck
		_ig
		_ft
	}
	/////
	
	fragment AuthenticationUser on User {
		id
		nodeId
		# profileCollection {
		# 	edges{node{...Node}}
		# }
		_UserToCompanyRoleCollection{edges{node {
			id
			company {
				nodeId
				id
				slug
				name
				hasLogo
				logoPath
				coverPath
				hasCover
				description
			}
			
		}}}
		# LinkedUsersToCompaniesConnection{edge{node{role
		# roles //need tiwari from sql 
		# 	}}}
		# currentPasswordCheck//need tiwari from sql
		god
		firebaseToken
	}*/
}
